const skills = [
  { id: "DIR", label: "director" },
  { id: "PNT", label: "painter" },
  { id: "WLD", label: "welder" },
  { id: "FTTR", label: "fitter" },
];

export default skills;
